export const PaymentRequestObjectKeys: string[] = [
  'Payload',
  'StoreCard',
  'OrderNote',
  'RecaptchaResponse',
  'IpAddress',
  'IsEmbeddedHostedPayment',
  'GivingPageContact',
  'GivingPageBillingAddress',
  'GivingPageDonation'
];